import type { PlaceMarker } from '../JuraMap/data'

export const markers: PlaceMarker[] = [
  {
    id: '1',
    content: {
      pl: {
        title: 'Morsowanie',
        description:
          'Przy ujściu rzeki Centuria, w miejscowości Hutki-Kanki udaj się na trening morsowania, który zahartuje Twój organizm wzmacniając jego odporność, ujędrniając ciało i regenerując mięśnie.',
      },
      en: {
        title: 'Winter Swimming',
        description:
          'Head to the mouth of the Centuria River in Hutki-Kanki for a winter swimming training that will toughen your body, boost its immunity, firm your physique, and regenerate your muscles.',
      },
    },
    position: { lat: 50.412_378_798_253_56, lng: 19.484_682_807_153_57 },
    img: '/static/img/sport/woda.jpg',
  },
  {
    id: '2',
    content: {
      pl: {
        title: 'Stadnina w Udorzu',
        description:
          'Jedna z najstarszych stadnin w regionie, na jej terenie znajdują się zabytkowe spichlerze, parki i stawy rybne. Nauka jeździectwa pod okiem doświadczonych instruktorów i rozległy parkur (tor z przeszkodami) oraz kryta ujeżdżalnia (o rozmiarach 60 na 18 m). Dla chętnych organizowane są rajdy wierzchem, przejażdżki bryczką i kuligi.',
      },
      en: {
        title: 'Udórz Equestrian Center',
        description:
          'One of the oldest equestrian centers in the region, it features historic granaries, parks, and fish ponds. Learn horse riding under the guidance of experienced instructors and enjoy a spacious obstacle course and a covered riding arena (60 by 18 meters). For the enthusiasts, horseback riding excursions, carriage rides, and sleigh rides are organized.',
      },
    },
    position: { lat: 50.462_917_083_899_54, lng: 19.778_201_873_891_01 },
    img: '/static/img/sport/kon2.jpg',
  },
  {
    id: '3',
    content: {
      pl: {
        title: 'Stajnia Ryczówek',
        description:
          'Lokalna Stajnia u Zbyszka w Ryczówku oferuje naukę jazdy konnej, szkolenia jeźdźca wraz z koniem, przejażdżki w teren, a także zajęcia z medytacji konnej.',
      },
      en: {
        title: 'Ryczówek Stables',
        description:
          "Local Zbyszek's Stables in Ryczówek offer horse riding lessons, rider and horse training, trail rides, and horse meditation sessions.",
      },
    },
    position: { lat: 50.397_962_944_504_57, lng: 19.554_321_555_459_413 },
    img: '/static/img/sport/kon.jpg',
  },
  {
    id: '4',
    content: {
      pl: {
        title: 'Narty - Cisowa',
        description:
          'W Cisowej są dwie trasy: niebieską o długości 700 metrów oraz czerwoną o długości 550 metrów.  Obie oświetlone, ratrakowane oraz ze sztucznym naśnieżaniem. Na miejscu znajduje się też wypożyczalnia sprzętu, serwis i szkoła narciarska.',
      },
      en: {
        title: 'Skiing - Cisowa',
        description:
          'Cisowa offers two slopes: a 700-meter blue slope and a 550-meter red slope. Both slopes are illuminated, groomed, and equipped with artificial snowmaking. There is also equipment rental, servicing, and a ski school available on-site.',
      },
    },
    position: { lat: 50.452_088_343_020_15, lng: 19.725_134_641_327_255 },
    img: '/static/img/sport/stok.jpg',
  },
  {
    id: '5',
    content: {
      pl: {
        title: 'Pilica - open water',
        description:
          'Poznaj wszystkie plusy jakie daje pływanie na łonie natury i oddaj się pływaniu open water w zbiorniku rzeki Pilica.',
      },
      en: {
        title: 'Pilica - Open Water',
        description:
          'Experience all the benefits of swimming in the heart of nature and indulge in open water swimming in the Pilica River reservoir.',
      },
    },
    position: { lat: 50.461_314, lng: 19.651_511 },
    img: '/static/img/sport/woda2.jpg',
  },
  {
    id: '6',
    content: {
      pl: {
        title: 'Golf - Rosa Private Golf Club',
        description:
          '65 kilometrów od hotelu pod Częstochową; na polu znajduje się 18 dołków, można na miejscu wypożyczyć sprzęt. Spektakularne widoki, oprócz idealnie utrzymanej nawierzchni trawiastej tworzą ozdobne drzewa i krzewy oraz ponad 30 km malowniczej linii brzegowej.',
      },
      en: {
        title: 'Golf - Rosa Private Golf Club',
        description:
          'Located 65 kilometers from the hotel near Częstochowa, Rosa Private Golf Club features an 18-hole course. Equipment rental is available on-site. The course offers spectacular views, adorned with decorative trees, shrubs, and over 30 kilometers of picturesque coastline.',
      },
    },
    position: { lat: 50.741_597_738_145_096, lng: 19.008_186_889_130_155 },
    img: '/static/img/sport/golf.jpg',
  },
  {
    id: '7',
    content: {
      pl: {
        title: 'Skała Furtki - wspinaczka',
        description:
          'Wysoka na 10 metrów wapienna skała w którą wkomponowany został mur  Zamku Ogrodzieniec. Na szczyt skały prowadzi 6 dróg wspinaczkowych.',
      },
      en: {
        title: 'Furtki Rock - Rock Climbing',
        description:
          'Furtki Rock is a 10-meter-high limestone cliff integrated with the wall of Zamku Ogrodzieniec. There are 6 climbing routes leading to the top of the cliff.',
      },
    },
    position: { lat: 50.452_706_357_027_9, lng: 19.552_492_700_054_263 },
    img: '/static/img/sport/wspinaczka3.jpg',
  },
  {
    id: '8',
    content: {
      pl: {
        title: 'Skała Niedźwiedź',
        description:
          'Skała ciesząca się dużą popularnością wśród wspinaczy skalnych. Znajduje się na niej aż 12 dróg wspinaczkowych o zróżnicowanej trudności. ',
      },
      en: {
        title: 'Bear Rock',
        description:
          'A rock popular among rock climbers. It features 12 climbing routes of varying difficulty.',
      },
    },
    position: { lat: 50.452_512_935_690_15, lng: 19.553_165_602_116_408 },
    img: '/static/img/sport/wspinaczka.jpg',
  },
  {
    id: '9',
    content: {
      pl: {
        title: 'Skała Lalka',
        description:
          'Zbudowana z twardych wapieni, ma postać słupa o wysokości 12 m.  Na szczyt prowadzi jedna droga wspinaczkowa z 4 ringami i stanowiskiem zjazdowym. ',
      },
      en: {
        title: 'Doll Rock',
        description:
          'Made of hard limestone, it takes the form of a pillar with a height of 12 m. There is one climbing route leading to the top, equipped with 4 rings and a rappelling station.',
      },
    },
    position: { lat: 50.452_528_741_877_8, lng: 19.553_342_569_581_584 },
    img: '/static/img/sport/wspinaczka2.jpg',
  },
  {
    id: '10',
    content: {
      pl: {
        title: 'Narty - Morsko',
        description:
          'W Morsku są dwa stoki: duży o długości 400 metrów i mały, tzw. „ośla łączka” o długości 110 metrów. Oba są oświetlone, ratrakowane i sztucznie naśnieżane. Przy stoku znajduje się wypożyczalnia sprzętu, serwis i szkoła narciarska.',
      },
      en: {
        title: 'Skiing - Morsko',
        description:
          "There are two slopes in Morsko: a large one, 400 meters long, and a small one called 'Donkey Meadow' with a length of 110 meters. Both slopes are illuminated, groomed, and artificially snowed. There is equipment rental, servicing, and a ski school available at the slope.",
      },
    },
    position: { lat: 50.554_002_373_222_836, lng: 19.521_232_853_970_766 },
    img: '/static/img/sport/trasa.jpg',
  },
  {
    id: '11',
    content: {
      pl: {
        title: 'Spływy Białką',
        description:
          'Wsiądź do kajaku i spłyń rzeką Białką w Lelowie. Do wyboru jest 6-kilometrowa Trasa Rodzinna oraz trudniejsza, 18-kilometrowa Trasa Przygodowa (minimalny próg wiekowy to 14 lat). Po drodze mija się ruiny starych młynów, zwalone drzewa, a przy odrobinie szczęścia zobaczyć można bobry. Spływy kajakowe organizujemy indywidualnie, o szczegóły zapytaj w recepcji.',
      },
      en: {
        title: 'Białka River Rafting',
        description:
          'Hop in a kayak and float down the Białka River in Lelów. You can choose between a 6-kilometer Family Route and a more challenging 18-kilometer Adventure Route (minimum age requirement is 14 years). Along the way, you will pass ruins of old mills, fallen trees, and with a bit of luck, you may spot beavers. We organize individual kayak trips, inquire at the reception for details.',
      },
    },
    position: { lat: 50.679_626_120_155_76, lng: 19.619_688_139_909_226 },
    img: '/static/img/sport/kajaki2.jpg',
  },
  {
    id: '12',
    content: {
      pl: {
        title: 'Krakow Valley Golf ',
        description:
          'Krakow Valley Golf znajduje się w odległości 45 kilometrów od hotelu na polu znajduje się 18 dołków. Na miejscu można wypożyczyć sprzęt.',
      },
      en: {
        title: 'Krakow Valley Golf',
        description:
          'Krakow Valley Golf is located 45 kilometers away from the hotel and features an 18-hole course. Equipment rental is available on-site.',
      },
    },
    position: { lat: 50.184_771_606_146_136, lng: 19.652_395_148_018_2 },
    img: '/static/img/sport/golf2.jpg',
  },
  {
    id: '13',
    content: {
      pl: {
        title: 'Skalne Miasto Podzamcza',
        description:
          'Wokół Zamku Ogrodzieniec wznoszą się uwielbiane przez amatorów wspinaczki liczne ostańce wapienne potocznie zwane Skalnym Miastem Podzamcza.',
      },
      en: {
        title: 'Rock City of Podzamcze',
        description:
          'Surrounding the Ogrodzieniec Castle, there are numerous limestone cliffs beloved by climbing enthusiasts, commonly known as the Rock City of Podzamcze.',
      },
    },
    position: { lat: 50.451_589_175_709_27, lng: 19.554_150_271_431_077 },
    img: '/static/img/sport/wspinaczka3.jpg',
  },
  {
    id: '14',
    content: {
      pl: {
        title: 'Pętle biegowe',
        description:
          'Trasy zarówno na poranny jogging, jak i kilkukilometrowe pętle na których praktycznie nie spotkamy drugiego człowieka. Polecamy:\n_ 5 km - przełaj przez las, obok skalnych ostańców pozwoli poczuć klimat Jury;\n_10 km - trasę na zespół skał Grochowiec; ZOBACZ MAPĘ\n_30 km - dużą pętlę; ZOBACZ MAPĘ',
      },
      en: {
        title: 'Running Loops',
        description:
          "Routes suitable for morning jogging as well as several-kilometer loops where you'll hardly encounter another person. We recommend:\n_ 5 km - cross-country run through the forest, passing by rocky outcrops to experience the atmosphere of the Jura region;\n_ 10 km - a trail to the Grochowiec rock formation; SEE MAP\n_ 30 km - a long loop; SEE MAP",
      },
    },
    position: { lat: 50.450_605_914_913_83, lng: 19.553_199_163_362_322 },
    img: '/static/img/sport/las-bieg.jpg',
  },
  {
    id: '15',
    content: {
      pl: {
        title: 'Narty - Smoleń',
        description:
          'Rodzinna stacja narciarska — 2 stoki o długości 420 i 280 metrów. Przy każdym wyciąg orczykowy. Stoki są oświetlone, regularnie ratrakowane oraz naśnieżane.',
      },
      en: {
        title: 'Skiing - Smoleń',
        description:
          'A family-friendly ski resort with 2 slopes, 420 and 280 meters long. Each slope has a T-bar lift. The slopes are illuminated, regularly groomed, and snow-covered.',
      },
    },
    position: { lat: 50.443_693_617_589_9, lng: 19.680_939_967_628_102 },
    img: '/static/img/sport/narty.jpg',
  },
  {
    id: '16',
    content: {
      pl: {
        title: 'Spływy Pilicą',
        description:
          'Spływ kajakowy rozpoczynamy w Szczekocinach, a kończymy przy moście kolejowym w Przyłęku. Po drodze dwa młyny i mały sztuczny próg wymagające przenosek. Rzeka bardzo kręta, malownicza z bogactwem przyrodniczym. Spływy kajakowe organizujemy indywidualnie, o szczegóły zapytaj w recepcji.',
      },
      en: {
        title: 'Canoeing on Pilica River',
        description:
          'We start the canoe trip in Szczekociny and finish at the railway bridge in Przyłęk. Along the way, there are two mills and a small artificial dam that require portages. The river is very winding, picturesque, and rich in natural beauty. Canoe trips are organized individually; for details, please inquire at the reception.',
      },
    },
    position: { lat: 50.625_372_018_596_5, lng: 19.826_815_627_028_89 },
    img: '/static/img/sport/kajaki.jpg',
  },
  {
    id: '17',
    content: {
      pl: {
        title: 'Góra Janowskiego',
        description:
          'Najwyższe wzniesienie Jury na którym znajduje się nasz hotel. Najwyższym punktem wzgórza jest skała Czubatka, ale prócz niej znajdują się tu liczne i atrakcyjne dla wspinaczy skały.',
      },
      en: {
        title: 'Janowski Mountain',
        description:
          'The highest elevation in Jura where our hotel is located. The highest point of the hill is the Czubatka rock, but there are also numerous other attractive rocks for climbers.',
      },
    },
    position: { lat: 50.453_518_546_904_63, lng: 19.570_345_523_253_934 },
    img: '/static/img/sport/gora.jpg',
  },
  {
    id: '18',
    content: {
      pl: {
        title: 'Pętle rowerowe',
        description:
          'Jura to rejon z zaskakująco rozwiniętą infrastrukturą ścieżek rowerowych prowadzących przez unikalny teren pełen skał, lasów, łąk i wąwozów oraz regularnej sieci dróg asfaltowych.\n_pętla szosowa na 40 km ZOBACZ MAPĘ\n_pętla szosowa na 20 km ZOBACZ MAPĘ',
      },
      en: {
        title: 'Cycling Loops',
        description:
          'Jura is an area with a surprisingly developed infrastructure of cycling paths that lead through a unique terrain full of rocks, forests, meadows, ravines, and a regular network of asphalt roads.\n_40 km road loop VIEW MAP\n_20 km road loop VIEW MAP',
      },
    },
    position: { lat: 50.450_576_211_719_48, lng: 19.553_128_397_326_98 },
    img: '/static/img/sport/rowery.jpg',
  },
  {
    id: '19',
    content: {
      pl: {
        title: 'Czubatka',
        description:
          'Zaliczana do grupy Cim na Podzamczu, wśród wspinaczy Czubatka cieszy się dużą popularnością. Wspinają się na jej północno-wschodniej, połogiej i pionowej ścianie. Poprowadzili na niej 7 dróg wspinaczkowycho trudności od IV do VI.2. Mają zamontowane stałe punkty asekuracyjne: ringi, stanowisko zjazdowe i dwa ringi zjazdowe.',
      },
      en: {
        title: 'Czubatka',
        description:
          'Belonging to the Cim na Podzamczu group, Czubatka is highly popular among climbers. They climb its northeast, gentle, and vertical wall. There are 7 climbing routes ranging in difficulty from IV to VI.2. Fixed safety points such as rings, belay stations, and two rappel rings are installed on it.',
      },
    },
    position: { lat: 50.452_057_712_176_96, lng: 19.555_743_413_847_235 },
    img: '/static/img/sport/czubatka.jpg',
  },
]
